import { surveyApi } from "api/surveyApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useSurvey = (surveyId: string | number | undefined) => {
  const queryClient = useQueryClient();
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.SURVEY(surveyId!),
    queryFn: () => surveyApi.fetchById(Number(surveyId)),
    enabled: !!surveyId,
  });
  const invalidate = () => {
    if (!surveyId) return;
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SURVEY(surveyId),
    });
  };

  return { invalidate, isLoading, survey: data?.data };
};
